import { useState as r, useEffect as t } from "react";
import n from "copy-to-clipboard";
export default function (o, e) {
  var i,
      u = function (r) {
    if (Array.isArray(r)) return r;
  }(i = r(!1)) || function (r, t) {
    var n = [],
        o = !0,
        e = !1,
        i = void 0;

    try {
      for (var u, a = r[Symbol.iterator](); !(o = (u = a.next()).done) && (n.push(u.value), 2 !== n.length); o = !0);
    } catch (r) {
      e = !0, i = r;
    } finally {
      try {
        o || null == a.return || a.return();
      } finally {
        if (e) throw i;
      }
    }

    return n;
  }(i) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }(),
      a = u[0],
      c = u[1],
      f = e && e.successDuration;

  return t(function () {
    if (a && f) {
      var r = setTimeout(function () {
        c(!1);
      }, f);
      return function () {
        clearTimeout(r);
      };
    }
  }, [a, f]), [a, function () {
    var r = n(o);
    c(r);
  }];
}